import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    padding: '5px 40px 5px 20px',
    borderTop: 'solid 1px #dfdfe6',
    borderBottom: 'solid 1px #dfdfe6',
    backgroundColor: '#fff',
    margin: '5px 0'
  },
  text: {
    color: '#5e6784',
    fontSize: 16
  },
  date: {
    color: '#5e6784',
    fontSize: 14
  }
}));

export default useStyles;
